import { render, staticRenderFns } from "./PageEditorToolbar.vue?vue&type=template&id=62cdb278&scoped=true"
import script from "./PageEditorToolbar.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cdb278",
  null
  
)

export default component.exports